import { FC, MouseEvent, useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export interface MemberActionsMenuProps {
  isPending: boolean;
  onResendInvite: () => void;
  onDelete: () => void;
}

const MemberActionsMenu: FC<MemberActionsMenuProps> = ({
  isPending,
  onResendInvite,
  onDelete,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleResendInvite = () => {
    handleClose();
    onResendInvite();
  };

  const handleDelete = () => {
    handleClose();
    onDelete();
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <IconButton
        aria-label="more"
        id="member-actions-button"
        aria-controls={open ? "member-actions-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{
          width: "32px",
          height: "32px",
          padding: 0,
          "&:hover": { backgroundColor: "rgba(208, 188, 255, 0.08)" },
        }}
        data-testid="member-actions-button"
      >
        <MoreVertIcon sx={{ width: "20px", height: "20px" }} />
      </IconButton>
      <Menu
        id="member-actions-menu"
        MenuListProps={{ "aria-labelledby": "member-actions-button" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {isPending && (
          <MenuItem onClick={handleResendInvite} data-testid="resend-invite">
            Resend Invite
          </MenuItem>
        )}
        <MenuItem onClick={handleDelete} data-testid="delete-member">
          Delete Member
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default MemberActionsMenu;
